import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'

const SCROLL_THRESHOLD = 20

@observer
class HomeSurveysTabs extends Component {
    @observable scrollStart = 0

    @observable scrollFinish = 0

    @observable isScrollingDown = false

    constructor(props) {
        super(props)
        this.state = {
            isVisible: true,
        }
    }

    componentDidMount = () => {
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        this.scrollFinish = window.scrollY
        this.scrollStart = window.scrollY
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = () => {
        const currentYPos = window.scrollY
        const { isVisible } = this.state
        if (currentYPos < SCROLL_THRESHOLD && !isVisible) this.setState({ isVisible: true })
        const isCurrentlyScrollingDown = currentYPos > this.scrollFinish

        const hasDirectionChanged = isCurrentlyScrollingDown !== this.isScrollingDown
        if (hasDirectionChanged) {
            this.scrollStart = currentYPos
            this.isScrollingDown = isCurrentlyScrollingDown
        }

        const scrollDistance = Math.abs(currentYPos - this.scrollStart)
        if (scrollDistance > SCROLL_THRESHOLD) {
            const shouldBeVisible = !this.isScrollingDown
            if (shouldBeVisible !== isVisible) {
                this.setState({ isVisible: shouldBeVisible })
                this.scrollStartY = currentYPos
            }
        }
        this.scrollFinish = currentYPos
    }

    render() {
        const { surveyTabs, activeTabKey, setActiveTabKey } = this.props
        const { isVisible } = this.state
        return (
            <div className={`switch-button ${isVisible ? '' : 'hide-tabs'}`}>
                <ul className="category-filter-menu">
                    {surveyTabs.map((tab) => (
                        <li key={tab.key}>
                            <Button
                                onClick={() => setActiveTabKey(tab.key)}
                                type="button"
                                cssClass={`${(activeTabKey === tab.key) ? 'active' : ''}`}
                            >
                                <i className="fa-regular fa-square-poll-vertical" />
                                {i18n.t(`home.taboptions.${tab.value}`)}
                            </Button>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

export default HomeSurveysTabs
